// extracted by mini-css-extract-plugin
module.exports = {"card":"GenreCard_card__YbTGg","icon":"GenreCard_icon__qYBrq","name":"GenreCard_name__4LOvO"};